module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section06_03_american-village-10f0e86cfa03bef072294d002cd2ffb5.jpg";